module.exports = __webpack_public_path__ + "img/george.b03823ee.jpeg";